<template>
  <page>
    <v-flex xs12>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title>
              <!-- Search table field -->
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                {{ labels.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="name"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td class="text-xs-left">{{ row.item.branch }}</td>
                      <td class="text-xs-left">{{ row.item.busCls }}</td>
                      <td class="text-xs-left">{{ row.item.polSILimDisp }}</td>
                      <td class="text-xs-left">{{ row.item.expDateDisp }}</td>
                      <td class="text-xs-left">{{ row.item.cesSILimDisp }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="helplist" width="900px" persistent>
      <!-- Helplist component -->
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete"> Are you sure to delete the selected VolCesLim - {{ deleteVolCesLim }} </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'

export default {
  data() {
    return {
      newMode: false,
      reviewMode: false,
      loading: false,
      submitting: false,
      promptRemove: false,
      showVolCesLim: false,
      helplist: false,
      XXXHelplist: false,
      items: [],
      totalItems: 0,
      deleteVolCesLim: '',
      selected: undefined,
      toggleArray: [false],
      labels: {
        newButton: 'New Voluntary Cession Limit',
        branch: 'Branch',
        busCls: 'Bus Cls',
        polSILim: 'Policy SI Limit',
        expDate: 'Expiry Date',
        cesSILim: 'Cession SI Limit',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        date: 'date'
      },
      filters: {
        branch: null,
        busCls: null,
        polSILim: null,
        expDate: null,
        cesSILim: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        date: null
      },
      form: {
        branch: undefined,
        busCls: undefined,
        polSILim: undefined,
        expDate: undefined,
        cesSILim: undefined,
        date: new Date()
      },
      headers: [
        { text: 'Branch', value: 'branch' },
        { text: 'Bus Cls', value: 'busCls' },
        { text: 'Policy SI Limit', value: 'polSILim' },
        { text: 'Expiry Date', value: 'expDate' },
        { text: 'Cession SI Limit', value: 'cesSILim' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    doClearFilters() {
      this.filters.branch = null
      this.filters.busCls = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    doNew() {
      this.newMode = true
      this.$router.push({ name: 'volCesLimDet', params: { volCesLimParam: 'new', tranMode: 'New' } })
    },
    async fetchData(option) {
      this.items = []
      this.resetMessages()
      const apiURI = this.menu.volCesLimList
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            data.map((volCesLimMap) => {
              const convertList = {
                branch: volCesLimMap.branch,
                branchDesc: volCesLimMap.branchDesc,
                busCls: volCesLimMap.busCls,
                busClsDesc: volCesLimMap.busClsDesc,
                expDate: volCesLimMap.expDate,
                expDateDisp: this.formatDate(volCesLimMap.expDate),
                polSILim: volCesLimMap.polSILim,
                polSILimDisp: formatDisplayNumber(volCesLimMap.polSILim),
                cesSILim: volCesLimMap.cesSILim,
                cesSILimDisp: formatDisplayNumber(volCesLimMap.cesSILim),
                cesSIPct: volCesLimMap.cesSIPct,
                acqApp: volCesLimMap.acqApp,
                comm2Pct: volCesLimMap.comm2Pct,
                comm2GN: volCesLimMap.comm2GN,
                defComm1AE: volCesLimMap.defComm1AE,
                defComm2AE: volCesLimMap.defComm2AE
              }
              this.items.push(convertList)
            })
            this.loading = false
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doQuery(data) {
      this.newMode = false
    },
    doReview(data) {
      this.newMode = false
      this.$router.push({ name: 'volCesLimDet', params: { volCesLimParam: data, tranMode: 'Review' } })
    },
    doDelete() {
      const apiURI = this.menu.deleteVolCesLim
      if (apiURI) {
        const expand = this.selected
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.fetchData()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doBack() {
      this.showVolCesLim = false
      this.newMode = true
    },
    doPromptRemove(data) {
      if (data) {
        this.resetMessages()
        this.promptRemove = true
        this.selected = data
        this.deleteVolCesLim = ' Branch: ' + data.branch + ', BusCls: ' + data.busCls + ', PolSILim: ' + data.polSILim
      }
    },
    formatDate(value) {
      return formatDisplayDate(value)
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    removeFormatNumber(value) {
      return removeFormatNumber(value)
    }
  },
  computed: {
    menu() {
      return this.$store.state.volCesLimParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {}
}
</script>
